import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta:{
      title: '首页'
    } 
  },

  //taobao
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('@/views/taobao/detail.vue'),
    meta:{
      title: '商品详情'
    } 
  }, 
  //搜索
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/taobao/search.vue'),
    meta:{
      title: '搜索'
    } 
  }, 
  //分类
  {
    path: '/category',
    name: 'Category',
    component: () => import('@/views/taobao/category.vue'),
    meta:{
      title: '搜索'
    } 
  }, 



  //我的
  {
    path: '/',
    name: 'Mine',
    component: () => import('@/views/Mine/index.vue'),
    meta:{
      title: '我的'
    } 
  },
  {
    path: '/orderDetail',
    name: 'OrderDetail',
    component: () => import('@/views/Mine/orderDetail.vue'),
    meta:{
      title: '订单'
    } 
  },
  {
    path: '/incomeStatement',
    name: 'IncomeStatement',
    component: () => import('@/views/Mine/incomeStatement.vue'),
    meta:{
      title: '收益报表'
    } 
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/views/Mine/withdraw.vue'),
    meta:{
      title: '余额提现'
    } 
  },
  {
    path: '/record',
    name: 'Record',
    component: () => import('@/views/Mine/record.vue'),
    meta:{
      title: '记录'
    } 
  },
  {
    path: '/invite',
    name: 'Invite',
    component: () => import('@/views/Mine/invite.vue'),
    meta:{
      title: '邀请'
    } 
  },
  {
    path: '/fans',
    name: 'Fans',
    component: () => import('@/views/Mine/fans.vue'),
    meta:{
      title: '团队'
    } 
  },
  {
    path: '/other',
    name: 'Other',
    component: () => import('@/views/Mine/other.vue'),
    meta:{
      title: '邀请'
    } 
  },
  //授权
  {
    path: '/authorize',
    name: 'Authorize',
    component: () => import('@/views/Mine/authorize.vue'),
    meta:{
      title: '授权'
    } 
  }, 
  //红包11
  {
    path: '/hongbao',
    name: 'Hongbao',
    component: () => import('@/views/taobao/hongbao.vue'),
    meta:{
      title: '双11每日红包'
    } 
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
